import SuspenseWrapper from '@src/components/suspenseWrapper';
import Loader from '@src/components/loader';
import lazyWithPreload from '@src/utils/lazyWithPreload';
import { RouteObject } from 'react-router-dom';
import { Path } from '../routes';
import Error from '@src/pages/error';
import Box from '@sendsprint/ui-react/dist/components/Box';
import { DashboardLayout, PlainLayout } from '@src/layouts';

export const SetupPage = lazyWithPreload(() => import('@src/pages/whiteLabel/setup'));
export const CustomiseProductPage = lazyWithPreload(
  () => import('@src/pages/whiteLabel/customiseProduct')
);
export const RatesAndFeesPage = lazyWithPreload(
  () => import('@src/pages/whiteLabel/ratesAndFees/ratesAndFeesHome')
);
export const RatesAndFeesDetailsPage = lazyWithPreload(
  () => import('@src/pages/whiteLabel/ratesAndFees/ratesAndFeesDetails')
);
export const SendersPage = lazyWithPreload(
  () => import('@src/pages/whiteLabel/senders/sendersHome')
);
export const SendersDetailsPage = lazyWithPreload(
  () => import('@src/pages/whiteLabel/senders/sendersDetails')
);
export const ReceiversPage = lazyWithPreload(
  () => import('@src/pages/whiteLabel/receivers/receiversHome')
);
export const ReceiversDetailsPage = lazyWithPreload(
  () => import('@src/pages/whiteLabel/receivers/receiversDetails')
);
export const TransactionsPage = lazyWithPreload(
  () => import('@src/pages/whiteLabel/transactions/transactionsHome')
);
export const TransactionsDetailsPage = lazyWithPreload(
  () => import('@src/pages/whiteLabel/transactions/transactionsDetails')
);
export const DashboardPage = lazyWithPreload(() => import('@src/pages/whiteLabel/dashboard'));

const routesData = [
  { path: Path.WhiteLabelSetup, component: <SetupPage /> },
  { path: Path.WhiteLabelDashboard, component: <DashboardPage /> },
  {
    path: Path.WhiteLabelRatesAndFees,
    component: <RatesAndFeesPage />
  },
  {
    path: `${Path.WhiteLabelRatesAndFees}/:id`,
    component: <RatesAndFeesDetailsPage />
  },
  {
    path: Path.WhiteLabelSenders,
    component: <SendersPage />
  },
  {
    path: `${Path.WhiteLabelSenders}/:id`,
    component: <SendersDetailsPage />
  },
  {
    path: Path.WhiteLabelReceivers,
    component: <ReceiversPage />
  },
  {
    path: `${Path.WhiteLabelReceivers}/:id`,
    component: <ReceiversDetailsPage />
  },
  {
    path: Path.WhiteLabelTransactions,
    component: <TransactionsPage />
  },
  {
    path: `${Path.WhiteLabelTransactions}/:id`,
    component: <TransactionsDetailsPage />
  }
];
const plainRoutesData = [
  { path: Path.WhiteLabelCustomiseProduct, component: <CustomiseProductPage /> }
];

export const whiteLabelChildrenRoutes: RouteObject[] = routesData.map(({ component, path }) => ({
  path,
  element: (
    <SuspenseWrapper
      errorFallback={({ resetError }) => (
        <Box className="">
          <Error resetError={resetError} />
        </Box>
      )}
      suspenseFallback={<Loader className="" showTimedOutScreen />}>
      {component}
    </SuspenseWrapper>
  )
}));

export const plainWhiteLabelRoutes: RouteObject[] = plainRoutesData.map(({ component, path }) => ({
  path,
  element: (
    <SuspenseWrapper
      errorFallback={({ resetError }) => (
        <Box className="">
          <Error resetError={resetError} />
        </Box>
      )}
      suspenseFallback={<Loader className="" showTimedOutScreen />}>
      {component}
    </SuspenseWrapper>
  )
}));

export const whiteLabelRoutes: RouteObject[] = [
  {
    element: <DashboardLayout client="white-label" setFixedMainWidth />,
    children: whiteLabelChildrenRoutes
  },
  {
    element: <PlainLayout />,
    children: plainWhiteLabelRoutes
  }
];
